"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationToolListStatusEnum = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WorkspaceStatus = exports.WorkspaceList200ResponseObjectEnum = exports.WorkspaceObjectEnum = exports.TemplateList200ResponseDataInnerObjectEnum = exports.TemplateList200ResponseObjectEnum = exports.ShareLinkType = exports.ShareLinkObjectEnum = exports.SearchPayloadPropertiesInnerOperatorEnum = exports.IntegrationToolRunArtifactKindEnum = exports.IntegrationToolRunObjectEnum = exports.IntegrationToolList200ResponseObjectEnum = exports.IntegrationToolStatusEnum = exports.IntegrationStatus = exports.IntegrationList200ResponseObjectEnum = exports.IntegrationDefinitionType = exports.IntegrationDefinitionList200ResponseObjectEnum = exports.IntegrationObjectEnum = exports.DocumentList200ResponseObjectEnum = exports.DocumentCreateRequestContentTypeEnum = exports.DocumentChunks200ResponseObjectEnum = exports.DocumentChunk200ResponseObjectEnum = exports.DocumentChunkObjectEnum = exports.DocumentObjectEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.DocumentObjectEnum = {
    Document: 'document'
};
exports.DocumentChunkObjectEnum = {
    DocumentChunk: 'document_chunk'
};
exports.DocumentChunk200ResponseObjectEnum = {
    DocumentChunk: 'document_chunk'
};
exports.DocumentChunks200ResponseObjectEnum = {
    List: 'list'
};
exports.DocumentCreateRequestContentTypeEnum = {
    Text: 'text',
    Markdown: 'markdown',
    Code: 'code'
};
exports.DocumentList200ResponseObjectEnum = {
    List: 'list'
};
exports.IntegrationObjectEnum = {
    IntegrationInstance: 'integration_instance'
};
exports.IntegrationDefinitionList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IntegrationDefinitionType = {
    Service: 'service',
    External: 'external'
};
exports.IntegrationList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IntegrationStatus = {
    Created: 'created',
    Provisioning: 'provisioning',
    Active: 'active',
    Inactive: 'inactive',
    Error: 'error'
};
exports.IntegrationToolStatusEnum = {
    Published: 'published',
    Draft: 'draft',
    Archived: 'archived'
};
exports.IntegrationToolList200ResponseObjectEnum = {
    List: 'list'
};
exports.IntegrationToolRunObjectEnum = {
    IntegrationRun: 'integration_run'
};
exports.IntegrationToolRunArtifactKindEnum = {
    Document: 'document'
};
exports.SearchPayloadPropertiesInnerOperatorEnum = {
    Eq: 'eq',
    Neq: 'neq',
    In: 'in'
};
exports.ShareLinkObjectEnum = {
    ShareLink: 'share_link'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ShareLinkType = {
    Form: 'form'
};
exports.TemplateList200ResponseObjectEnum = {
    List: 'list'
};
exports.TemplateList200ResponseDataInnerObjectEnum = {
    Template: 'template'
};
exports.WorkspaceObjectEnum = {
    Workspace: 'workspace'
};
exports.WorkspaceList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.WorkspaceStatus = {
    Active: 'active',
    Archived: 'archived',
    Error: 'error',
    Provisioning: 'provisioning',
    Created: 'created'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary document chunk
         * @param {string} documentId
         * @param {string} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentChunk: async (documentId, index, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('documentChunk', 'documentId', documentId);
            // verify required parameter 'index' is not null or undefined
            (0, common_1.assertParamExists)('documentChunk', 'index', index);
            const localVarPath = `/documents/{documentId}/chunks/{index}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary document chunks
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentChunks: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('documentChunks', 'documentId', documentId);
            const localVarPath = `/documents/{documentId}/chunks`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary document delete
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDelete: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('documentDelete', 'documentId', documentId);
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary document list
         * @param {number} [limit]
         * @param {string} [domain]
         * @param {string} [objectType]
         * @param {string} [object]
         * @param {Array<string>} [objects]
         * @param {string} [parent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentList: async (limit, domain, objectType, object, objects, parent, options = {}) => {
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }
            if (objectType !== undefined) {
                localVarQueryParameter['objectType'] = objectType;
            }
            if (object !== undefined) {
                localVarQueryParameter['object'] = object;
            }
            if (objects) {
                localVarQueryParameter['objects'] = objects;
            }
            if (parent !== undefined) {
                localVarQueryParameter['parent'] = parent;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary document retrieve
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentRetrieve: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('documentRetrieve', 'documentId', documentId);
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary document search
         * @param {SearchPayload} [searchPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentSearch: async (searchPayload, options = {}) => {
            const localVarPath = `/documents/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(searchPayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary document set
         * @param {DocumentCreateRequest} [documentCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentSet: async (documentCreateRequest, options = {}) => {
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration create
         * @param {IntegrationCreatePayload} [integrationCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationCreate: async (integrationCreatePayload, options = {}) => {
            const localVarPath = `/integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration_definition list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationDefinitionList: async (limit, options = {}) => {
            const localVarPath = `/integration-definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration_definition retrieve
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationDefinitionRetrieve: async (definitionId, options = {}) => {
            // verify required parameter 'definitionId' is not null or undefined
            (0, common_1.assertParamExists)('integrationDefinitionRetrieve', 'definitionId', definitionId);
            const localVarPath = `/integration-definitions/{definitionId}`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration delete
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationDelete: async (integrationId, options = {}) => {
            // verify required parameter 'integrationId' is not null or undefined
            (0, common_1.assertParamExists)('integrationDelete', 'integrationId', integrationId);
            const localVarPath = `/integrations/{integrationId}`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration list
         * @param {string} [workspace]
         * @param {string} [definition]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationList: async (workspace, definition, limit, options = {}) => {
            const localVarPath = `/integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (workspace !== undefined) {
                localVarQueryParameter['workspace'] = workspace;
            }
            if (definition !== undefined) {
                localVarQueryParameter['definition'] = definition;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration retrieve
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationRetrieve: async (integrationId, options = {}) => {
            // verify required parameter 'integrationId' is not null or undefined
            (0, common_1.assertParamExists)('integrationRetrieve', 'integrationId', integrationId);
            const localVarPath = `/integrations/{integrationId}`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration_tool_config retrieve
         * @param {string} integrationToolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolConfigRetrieve: async (integrationToolId, options = {}) => {
            // verify required parameter 'integrationToolId' is not null or undefined
            (0, common_1.assertParamExists)('integrationToolConfigRetrieve', 'integrationToolId', integrationToolId);
            const localVarPath = `/integration-tools/{integrationToolId}/config`
                .replace(`{${"integrationToolId"}}`, encodeURIComponent(String(integrationToolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration_tool list
         * @param {string} [integrationDefinitionId]
         * @param {string} [slug]
         * @param {string} [category] Filter by tool category
         * @param {IntegrationToolListStatusEnum} [status] Filter by tool status
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolList: async (integrationDefinitionId, slug, category, status, limit, options = {}) => {
            const localVarPath = `/integration-tools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (integrationDefinitionId !== undefined) {
                localVarQueryParameter['integration_definition_id'] = integrationDefinitionId;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration_tool retrieve
         * @param {string} integrationToolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolRetrieve: async (integrationToolId, options = {}) => {
            // verify required parameter 'integrationToolId' is not null or undefined
            (0, common_1.assertParamExists)('integrationToolRetrieve', 'integrationToolId', integrationToolId);
            const localVarPath = `/integration-tools/{integrationToolId}`
                .replace(`{${"integrationToolId"}}`, encodeURIComponent(String(integrationToolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration_tool_run create
         * @param {IntegrationToolRunCreateRequest} [integrationToolRunCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolRunCreate: async (integrationToolRunCreateRequest, options = {}) => {
            const localVarPath = `/integration-tool-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationToolRunCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary integration update
         * @param {string} integrationId
         * @param {IntegrationUpdatePayload} [integrationUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationUpdate: async (integrationId, integrationUpdatePayload, options = {}) => {
            // verify required parameter 'integrationId' is not null or undefined
            (0, common_1.assertParamExists)('integrationUpdate', 'integrationId', integrationId);
            const localVarPath = `/integrations/{integrationId}`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationUpdatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary share_link create
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareLinkCreate: async (body, options = {}) => {
            const localVarPath = `/share_links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary template list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateList: async (limit, options = {}) => {
            const localVarPath = `/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace create
         * @param {WorkspaceCreatePayload} [workspaceCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceCreate: async (workspaceCreatePayload, options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workspaceCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceList: async (limit, options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workspace retrieve
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceRetrieve: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('workspaceRetrieve', 'workspaceId', workspaceId);
            const localVarPath = `/workspaces/{workspaceId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary document chunk
         * @param {string} documentId
         * @param {string} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentChunk(documentId, index, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentChunk(documentId, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentChunk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary document chunks
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentChunks(documentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentChunks(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentChunks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary document delete
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentDelete(documentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentDelete(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary document list
         * @param {number} [limit]
         * @param {string} [domain]
         * @param {string} [objectType]
         * @param {string} [object]
         * @param {Array<string>} [objects]
         * @param {string} [parent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentList(limit, domain, objectType, object, objects, parent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentList(limit, domain, objectType, object, objects, parent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary document retrieve
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentRetrieve(documentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentRetrieve(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary document search
         * @param {SearchPayload} [searchPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentSearch(searchPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentSearch(searchPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary document set
         * @param {DocumentCreateRequest} [documentCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentSet(documentCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentSet(documentCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.documentSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration create
         * @param {IntegrationCreatePayload} [integrationCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationCreate(integrationCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationCreate(integrationCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration_definition list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationDefinitionList(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationDefinitionList(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationDefinitionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration_definition retrieve
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationDefinitionRetrieve(definitionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationDefinitionRetrieve(definitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationDefinitionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration delete
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationDelete(integrationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationDelete(integrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration list
         * @param {string} [workspace]
         * @param {string} [definition]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationList(workspace, definition, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationList(workspace, definition, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration retrieve
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationRetrieve(integrationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationRetrieve(integrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration_tool_config retrieve
         * @param {string} integrationToolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationToolConfigRetrieve(integrationToolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationToolConfigRetrieve(integrationToolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationToolConfigRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration_tool list
         * @param {string} [integrationDefinitionId]
         * @param {string} [slug]
         * @param {string} [category] Filter by tool category
         * @param {IntegrationToolListStatusEnum} [status] Filter by tool status
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationToolList(integrationDefinitionId, slug, category, status, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationToolList(integrationDefinitionId, slug, category, status, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationToolList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration_tool retrieve
         * @param {string} integrationToolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationToolRetrieve(integrationToolId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationToolRetrieve(integrationToolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationToolRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration_tool_run create
         * @param {IntegrationToolRunCreateRequest} [integrationToolRunCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationToolRunCreate(integrationToolRunCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationToolRunCreate(integrationToolRunCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationToolRunCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary integration update
         * @param {string} integrationId
         * @param {IntegrationUpdatePayload} [integrationUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationUpdate(integrationId, integrationUpdatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationUpdate(integrationId, integrationUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.integrationUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary share_link create
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareLinkCreate(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareLinkCreate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.shareLinkCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary template list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateList(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateList(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.templateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace create
         * @param {WorkspaceCreatePayload} [workspaceCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceCreate(workspaceCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceCreate(workspaceCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace list
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceList(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceList(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workspace retrieve
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceRetrieve(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceRetrieve(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workspaceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary document chunk
         * @param {DefaultApiDocumentChunkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentChunk(requestParameters, options) {
            return localVarFp.documentChunk(requestParameters.documentId, requestParameters.index, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary document chunks
         * @param {DefaultApiDocumentChunksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentChunks(requestParameters, options) {
            return localVarFp.documentChunks(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary document delete
         * @param {DefaultApiDocumentDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDelete(requestParameters, options) {
            return localVarFp.documentDelete(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary document list
         * @param {DefaultApiDocumentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentList(requestParameters = {}, options) {
            return localVarFp.documentList(requestParameters.limit, requestParameters.domain, requestParameters.objectType, requestParameters.object, requestParameters.objects, requestParameters.parent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary document retrieve
         * @param {DefaultApiDocumentRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentRetrieve(requestParameters, options) {
            return localVarFp.documentRetrieve(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary document search
         * @param {DefaultApiDocumentSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentSearch(requestParameters = {}, options) {
            return localVarFp.documentSearch(requestParameters.searchPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary document set
         * @param {DefaultApiDocumentSetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentSet(requestParameters = {}, options) {
            return localVarFp.documentSet(requestParameters.documentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration create
         * @param {DefaultApiIntegrationCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationCreate(requestParameters = {}, options) {
            return localVarFp.integrationCreate(requestParameters.integrationCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration_definition list
         * @param {DefaultApiIntegrationDefinitionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationDefinitionList(requestParameters = {}, options) {
            return localVarFp.integrationDefinitionList(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration_definition retrieve
         * @param {DefaultApiIntegrationDefinitionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationDefinitionRetrieve(requestParameters, options) {
            return localVarFp.integrationDefinitionRetrieve(requestParameters.definitionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration delete
         * @param {DefaultApiIntegrationDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationDelete(requestParameters, options) {
            return localVarFp.integrationDelete(requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration list
         * @param {DefaultApiIntegrationListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationList(requestParameters = {}, options) {
            return localVarFp.integrationList(requestParameters.workspace, requestParameters.definition, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration retrieve
         * @param {DefaultApiIntegrationRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationRetrieve(requestParameters, options) {
            return localVarFp.integrationRetrieve(requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration_tool_config retrieve
         * @param {DefaultApiIntegrationToolConfigRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolConfigRetrieve(requestParameters, options) {
            return localVarFp.integrationToolConfigRetrieve(requestParameters.integrationToolId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration_tool list
         * @param {DefaultApiIntegrationToolListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolList(requestParameters = {}, options) {
            return localVarFp.integrationToolList(requestParameters.integrationDefinitionId, requestParameters.slug, requestParameters.category, requestParameters.status, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration_tool retrieve
         * @param {DefaultApiIntegrationToolRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolRetrieve(requestParameters, options) {
            return localVarFp.integrationToolRetrieve(requestParameters.integrationToolId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration_tool_run create
         * @param {DefaultApiIntegrationToolRunCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationToolRunCreate(requestParameters = {}, options) {
            return localVarFp.integrationToolRunCreate(requestParameters.integrationToolRunCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary integration update
         * @param {DefaultApiIntegrationUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationUpdate(requestParameters, options) {
            return localVarFp.integrationUpdate(requestParameters.integrationId, requestParameters.integrationUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary share_link create
         * @param {DefaultApiShareLinkCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareLinkCreate(requestParameters = {}, options) {
            return localVarFp.shareLinkCreate(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary template list
         * @param {DefaultApiTemplateListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateList(requestParameters = {}, options) {
            return localVarFp.templateList(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace create
         * @param {DefaultApiWorkspaceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceCreate(requestParameters = {}, options) {
            return localVarFp.workspaceCreate(requestParameters.workspaceCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace list
         * @param {DefaultApiWorkspaceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceList(requestParameters = {}, options) {
            return localVarFp.workspaceList(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workspace retrieve
         * @param {DefaultApiWorkspaceRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceRetrieve(requestParameters, options) {
            return localVarFp.workspaceRetrieve(requestParameters.workspaceId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary document chunk
     * @param {DefaultApiDocumentChunkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentChunk(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentChunk(requestParameters.documentId, requestParameters.index, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary document chunks
     * @param {DefaultApiDocumentChunksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentChunks(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentChunks(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary document delete
     * @param {DefaultApiDocumentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentDelete(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary document list
     * @param {DefaultApiDocumentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentList(requestParameters.limit, requestParameters.domain, requestParameters.objectType, requestParameters.object, requestParameters.objects, requestParameters.parent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary document retrieve
     * @param {DefaultApiDocumentRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentRetrieve(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary document search
     * @param {DefaultApiDocumentSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentSearch(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentSearch(requestParameters.searchPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary document set
     * @param {DefaultApiDocumentSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentSet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentSet(requestParameters.documentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration create
     * @param {DefaultApiIntegrationCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationCreate(requestParameters.integrationCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration_definition list
     * @param {DefaultApiIntegrationDefinitionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationDefinitionList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationDefinitionList(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration_definition retrieve
     * @param {DefaultApiIntegrationDefinitionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationDefinitionRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationDefinitionRetrieve(requestParameters.definitionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration delete
     * @param {DefaultApiIntegrationDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationDelete(requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration list
     * @param {DefaultApiIntegrationListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationList(requestParameters.workspace, requestParameters.definition, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration retrieve
     * @param {DefaultApiIntegrationRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationRetrieve(requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration_tool_config retrieve
     * @param {DefaultApiIntegrationToolConfigRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationToolConfigRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationToolConfigRetrieve(requestParameters.integrationToolId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration_tool list
     * @param {DefaultApiIntegrationToolListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationToolList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationToolList(requestParameters.integrationDefinitionId, requestParameters.slug, requestParameters.category, requestParameters.status, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration_tool retrieve
     * @param {DefaultApiIntegrationToolRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationToolRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationToolRetrieve(requestParameters.integrationToolId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration_tool_run create
     * @param {DefaultApiIntegrationToolRunCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationToolRunCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationToolRunCreate(requestParameters.integrationToolRunCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary integration update
     * @param {DefaultApiIntegrationUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    integrationUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).integrationUpdate(requestParameters.integrationId, requestParameters.integrationUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary share_link create
     * @param {DefaultApiShareLinkCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    shareLinkCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).shareLinkCreate(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary template list
     * @param {DefaultApiTemplateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    templateList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).templateList(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace create
     * @param {DefaultApiWorkspaceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceCreate(requestParameters.workspaceCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace list
     * @param {DefaultApiWorkspaceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceList(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workspace retrieve
     * @param {DefaultApiWorkspaceRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workspaceRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workspaceRetrieve(requestParameters.workspaceId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * @export
 */
exports.IntegrationToolListStatusEnum = {
    Published: 'published',
    Draft: 'draft',
    Archived: 'archived'
};
//# sourceMappingURL=api.js.map